<template>
    <div class="cloud-picture">
		<div class="divInput">
			<div class="input" @click="showOption=!showOption">
				<input type="text" readonly :placeholder="areaList[checkedIndex].name">
			</div>
			<ul class="list" v-show="showOption">
				<li @click="getvalue(item,index)" v-for="(item,index) in areaList" :key="index">{{ item.name }}</li>
			</ul>
		</div>
        <div class="head"></div>
        <ul  class="option">
            <li :class="showAlarm?'active button-box':'button-box'" @click="changePage(1)">报警数据</li>
            <li :class="showUser?'active button-box':'button-box'" @click="changePage(2)">用户数据</li>
            <li  :class="showCamera?'active button-box':'button-box'" @click="changePage(3)">摄像头数据</li>
        </ul>
		<user-data :clouldAreaCode="areaList[checkedIndex].centerCode" v-if="showUser"></user-data>
		<data-alarm :clouldAreaCode="areaList[checkedIndex].centerCode" v-if="showAlarm"> </data-alarm>
		<cameraData :clouldAreaCode="areaList[checkedIndex].centerCode" v-if="showCamera"> </cameraData>
    </div>
</template>

<script>
    import cameraData from "./child-Component/cameraData";
    import DataAlarm from "./child-Component/dataAlarm";
    import UserData from "./child-Component/userData";
    export default {
        name: "cloud-picture",
        components:{
            UserData,
            DataAlarm,
            cameraData,
        },
        data(){
            return{
				areaList:[],
				checkedIndex:0,
				showOption:false,
				
				showUser:false,
                showAlarm:false,
				showCamera:true,
				screenWidth: document.body.clientWidth, // 屏幕宽度
                screenHeight: document.body.clientHeight, // 屏幕高度
            }
        },
        created() {
			let userInfo=JSON.parse(localStorage.getItem('ur'));
			this.areaList=userInfo.centerList;
        },
		mounted() {
			console.log(this.screenWidth);
			console.log(this.screenHeight);
		},
        methods:{
			getvalue(item,index){
				this.checkedIndex=index;
				this.showOption=!this.showOption;
			},
			changePage(type){
				if(type==1){
					this.showUser=false;
					this.showAlarm=true;
					this.showCamera=false;
				}else if(type==2){
					this.showUser=true;
					this.showAlarm=false;
					this.showCamera=false;
				}else{
					this.showUser=false;
					this.showAlarm=false;
					this.showCamera=true;
				}
			}
        }
    }
</script>

<style lang="less" scoped>
    @import "./cloud-picture";
	.active{
		background: url(../../assets/images/cloud/activeBtn.png);
		background-size: 100% 100%;
	}
</style>